// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OYK61","name":"styles_name__3eddP","phone":"styles_phone__3Z1bA"};